<template>
  <ModuleWrapper
    :moduleId="moduleId"
    :image="imageSrcPath('assets/branding/button-card-color.svg')"
    title="Name Card"
    @initializeData="initializeData"
  >
    <template #main>
      <StudioToggleWithLabel
        id="name-card-toggle"
        label="Name Cards"
        :checked="isNameCardEnable"
        @update:checked="toggleNameCard"
      />
      <template v-if="isNameCardEnable">
        <StudioSelect
          id="card-type-picker"
          label="Card Type"
          :options="[
            { value: '20px', label: 'Rounded' },
            { value: '10px', label: 'Rectangular' }
          ]"
          size="small"
          orientation="horizontal"
          class="tw-mb-4 tw-mt-4"
          :value="nameCardRadius"
          @change="onSelectCardBorderRadius"
        />
        <StudioToggleWithLabel
          id="show-speaker-title-toggle"
          label="Show Speaker Title &amp; Company"
          class="tw-mb-4"
          :checked="showSpeakerTitle"
          @update:checked="toggleSpeakerTitle"
        />
        <StudioToggleWithLabel
          id="reverse-gradient-toggle"
          label="Reverse Gradient Colors"
          :checked="isColorReverse"
          @update:checked="toggleColorReverse"
        />
      </template>
    </template>
  </ModuleWrapper>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import ModuleWrapper from './ModuleWrapper.vue';

import { StudioSelect, StudioToggleWithLabel } from '@/studioComponents';

export default {
  name: 'NameCard',
  components: {
    ModuleWrapper,
    StudioToggleWithLabel,
    StudioSelect
  },
  props: {
    moduleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isNameCardEnable: false,
      nameCardRadius: '20px',
      showSpeakerTitle: false,
      isGradient: false,
      isColorReverse: false,
      themeColors: {}
    };
  },
  created() {
    this.initializeData();
  },
  computed: {
    ...mapGetters('branding', {
      getInitialModuleData: 'getInitialModuleData'
    })
  },
  methods: {
    ...mapMutations('branding', ['setChangesMadeInThemeObj']),
    initializeData() {
      const moduleKeys = ['name_card_radius', 'name_card_title_display', 'name_card_background'];
      const {
        name_card_radius: nameCardRadius,
        name_card_title_display: nameCardTitleDisplay,
        name_card_background: nameCardBackground
      } = this.getInitialModuleData(moduleKeys);

      this.themeColors = {
        themeSecondaryColor: 'var(--theme-secondary-color)',
        secondaryTextColor: 'var(--secondary-text-color)'
      };

      // setting the initial inputs state
      this.isNameCardEnable = Boolean(nameCardTitleDisplay);
      this.nameCardRadius = nameCardRadius;
      this.showSpeakerTitle = nameCardTitleDisplay === 'visible';
      this.isGradient = Boolean(nameCardBackground);
      this.isColorReverse = nameCardBackground === this.themeColors.secondaryTextColor;
    },
    toggleNameCard(event) {
      const value = event.target.checked;
      this.isNameCardEnable = value;
      // resetting the inputs to default state
      this.nameCardRadius = '20px';
      this.showSpeakerTitle = false;
      this.isGradient = false;
      this.isColorReverse = false;

      const payload = this.getToggleNameCardPayload();
      this.setChangesMadeInThemeObj(payload);
    },
    onSelectCardBorderRadius(e) {
      const selectedBorderRadius = e.target.value;
      this.nameCardRadius = selectedBorderRadius;
      this.setChangesMadeInThemeObj({
        name_card_radius: selectedBorderRadius
      });
    },
    toggleSpeakerTitle(event) {
      const value = event.target.checked;
      this.showSpeakerTitle = value;
      this.setChangesMadeInThemeObj({
        name_card_title_display: value ? 'visible' : 'none'
      });
    },
    toggleColorReverse(event) {
      const value = event.target.checked;
      this.isColorReverse = value;
      const { themeSecondaryColor, secondaryTextColor } = this.themeColors;
      let payload;

      if (this.isColorReverse) {
        payload = {
          name_card_background: secondaryTextColor,
          name_card_text_color: themeSecondaryColor
        };
      } else {
        payload = {
          name_card_background: themeSecondaryColor,
          name_card_text_color: secondaryTextColor
        };
      }
      this.setChangesMadeInThemeObj(payload);
    },
    getToggleNameCardPayload() {
      const { themeSecondaryColor, secondaryTextColor } = this.themeColors;

      if (this.isNameCardEnable) {
        this.isGradient = true;
        return {
          name_card_title_display: 'none',
          name_card_radius: '20px',
          name_card_background: themeSecondaryColor,
          name_card_text_color: secondaryTextColor
        };
      }
      return {
        name_card_title_display: null,
        name_card_radius: null,
        name_card_background: null,
        name_card_text_color: null
      };
    }
  }
};
</script>
